import { connect } from "react-redux";
import CardStyles from "./Card.module.css";

const InfoCard = ({ header, content, footer }) => {
	return (
		<div className={CardStyles["card-body"]}>
			{header && <div className={CardStyles["card-header"]}>{header}</div>}
			{content && <div className={CardStyles["card-content"]}>{content}</div>}
			{footer && <div className={CardStyles["card-footer"]}>{footer}</div>}
		</div>
	);
};

const mapStateToProps = (state, { period }) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(InfoCard);
